// RelationshipPrompt. Mirrors data-component="relationship-prompt"
// from the approved HTML. The natural-next-question side card that
// nudges the rep to confirm the current care team.
//
// TODO(runtime): hydrate from services/priority-engine
// nextQuestion(contactId, horseId) once the HTTP endpoint lands.
import type { ReactNode } from 'react';
import { HORSE_PORTRAIT_PLACEHOLDER } from '../../../data/mockData.js';
import type { RelationshipPrompt as RelationshipPromptData } from '../mockData.js';

export interface RelationshipPromptProps {
  prompt: RelationshipPromptData;
  onRecordConnection: () => void;
  mediaUrl?: string;
}

export function RelationshipPrompt({
  prompt,
  onRecordConnection,
  mediaUrl,
}: RelationshipPromptProps): ReactNode {
  return (
    <section className="horse-prompt" data-component="relationship-prompt">
      <div className="prompt-media">
        <img src={mediaUrl ?? HORSE_PORTRAIT_PLACEHOLDER} alt="" />
      </div>
      <span className="eyebrow">A NATURAL NEXT QUESTION</span>
      <h3>&ldquo;{prompt.question}&rdquo;</h3>
      <p>{prompt.context}</p>
      <div className="prompt-facts">
        <span>{prompt.currentCount} current</span>
        <span>{prompt.careRoles} care roles</span>
        <span>
          {prompt.recentChanges} recent change
          {prompt.recentChanges === 1 ? '' : 's'}
        </span>
      </div>
      <button
        type="button"
        className="outlined"
        onClick={onRecordConnection}
      >
        Record a connection &nearr;
      </button>
    </section>
  );
}
